module.exports = __webpack_public_path__ + "static/media/ImgExcel.00675868.svg";